module.exports = __webpack_public_path__ + "static/media/IMG_0866.1fa262c3.JPG";